import React from 'react';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';

import ActionButton from '../../../components/ActionButton';
import CustomTable from './CustomTable';

import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    textAlign: 'center',
    padding: '10px',
    backgroundColor: 'white',
    color: 'black',
    boxShadow: theme.shadows[6],
    borderRadius: '6px',
    overflowY: 'auto',
  },
  title: {
    paddingTop: '20px',
    paddingBottom: '20px',
  },
}));

export default function ModalResponsabiliEsercizio(props) {
  const classes = useStyles();

  let columns = [
    {
      Header: 'ID',
      id: 'id',
      accessor: (r) => r.id,
      minWidth: 90,
    },
    {
      Header: 'Email',
      id: 'email',
      accessor: (r) => r.email,
      minWidth: 320,
    },
    {
      Header: 'Nome',
      id: 'nome',
      accessor: (r) => r.nome,
      minWidth: 180,
    },
    {
      Header: 'Cognome',
      id: 'cognome',
      accessor: (r) => r.cognome,
      minWidth: 180,
    },
  ];

  return (
    <Modal
      open={props.open}
      onClose={props.onCloseModal}
      className={classes.modal}
      aria-labelledby="modal_responsabili_esercizio"
      aria-describedby="modal_responsabili_esercizio"
    >
      <div className={classes.modalContainer}>
        <Container maxWidth="xl">
          <Typography variant="h6" className={classes.title}>
            {"Responsabili sicurezza collegati all'esercizio " +
              props.nomeEsercizio}
          </Typography>
          <Grid container justify="center" alignItems="center">
            {props.errorLabel === '' ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <CustomTable
                  columns={columns}
                  records={props.responsabili}
                  loading={false}
                  filterable={false}
                  resizable={false}
                  sortable={false}
                  defaultPageSize={5}
                />
              </Grid>
            ) : (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="body2" className={classes.title}>
                  {props.errorLabel}
                </Typography>
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <ActionButton
                label="Chiudi"
                onClick={props.onCloseModal}
                disabled={false}
                grayVersion={false}
                secondaryButton
              />
            </Grid>
          </Grid>
        </Container>
      </div>
    </Modal>
  );
}

ModalResponsabiliEsercizio.propTypes = {
  open: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  responsabili: PropTypes.array.isRequired,
  nomeEsercizio: PropTypes.string.isRequired,
  errorLabel: PropTypes.string.isRequired,
};
